export default {
  list: {},
};
